import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    UrlTree
} from '@angular/router';
import { SitesService } from '../services/sites.service';
import {filter, map, Observable, switchMap} from 'rxjs';
import {BrowserProviderService} from '../services/browser-provider.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class HasSitesGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AuthService, private siteService: SitesService, private browserService: BrowserProviderService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.redirectIfNoSites();
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.redirectIfNoSites();
    }

    redirectIfNoSites(): Observable<boolean | UrlTree> {
        return this.authService.IsReady.pipe(
            filter(isReady => !!isReady),
            switchMap(() => this.siteService.GetSites()),
            map(sites => {
                if (sites.length === 0) {
                    this.browserService.location.assign('/#/no-sites');

                    return false;
                }

                return true;
            }));
    }
}
